import React, { useState, useEffect, useRef } from 'react';
import './overview.scss';

// Components
// ---------------------
import { Tabs } from '../../components/tabs/tabs';

export const Overview = ({ ...props }) => {
  const [tabs] = useState([
    {
      label: 'Superior Liquidity',
      content:
        'SIGMA X MTF offers a superior source of liquidity, with flatter post-trade markouts and larger average execution size than competing order books, as demonstrated by third party analytics providers',
    },
    {
      label: 'Access to Liquidity Across Europe',
      content:
        'SIGMA X MTF was launched in 2011. The addition of SIGMA X Europe MTF, launched at the end of 2020 underscores Goldman Sachs’ broader commitment to servicing it’s clients within the European Union clients, providing comprehensive liquidity solutions to its international clients',
    },
    {
      label: 'Complementary Order Books',
      content:
        'SIGMA X offers 2 separate order books across SIGMA X MTF and SIGMA X Europe MTF:\n\n•\tThe SIGMA X Auction Book is a lit, pre-trade transparent and price-forming order book that facilitates periodic auctions during continuous trading hours. Its unique, patented anti-gaming functionality provides price certainty and price protection\n\n•\tThe SIGMA X Reference Price Book is completely dark - no pre-trade information about your order is ever conveyed to other participants. It offers trading on the mid-point of the Primary Best Bid and Offer',
    },
    {
      label: 'Safe Trading Environment',
      content:
        'We are committed to providing you a safe trading environment. Within Goldman Sachs, SIGMA X is operated on independent infrastructure and under a separate governance structure from that of other businesses. Any order from the Goldman Sachs franchise is treated identically to that of other Participants.',
    },
  ]);
  const [book, setBook] = useState([
    {
      active: true,
      label: 'Dark Book',
      content:
        'The SIGMA X Reference Price Book is completely dark, with no pre-trade information about your order ever conveyed to other participants. Participants are able to trade Dark and Conditionally, under the Reference Price Waiver and Large in Scale Waiver.',
    },
    {
      label: 'Periodic Auction Book',
      content:
        'The SIGMA X Auction Book is a lit, pre-trade transparent and price-forming order book that facilitates periodic auctions during continuous trading hours. Its unique, patented anti-gaming functionality provides price certainty and price protection',
    },
  ]);

  const handleBookClick = (e, index) => {
    setBook(
      book.map((book, i) => {
        if (i === index) {
          if (!book.active) {
            book.active = true;
          }
        } else {
          book.active = false;
        }
        return book;
      })
    );
  };

  return (
    <div className="overview-page">
      <div className="intro-block">
        <h1>SIGMA X MTF</h1>
        <span>Investing for our clients</span>
        <a
          className="request-info-link"
          aria-label="Request information by email"
          href="mailto:gssigmaxmtf@gs.com"
        >
          Request Information
        </a>
      </div>
      <div className="discover-block">
        <h1>Discover SIGMA X MTF</h1>
        <div className="discover-body">
          SIGMA X allows you to access superior liquidity, while providing
          opportunities for improved execution quality within a safe trading
          environment
        </div>
        <a aria-label="Learn more by email" href="mailto:gssigmaxmtf@gs.com">
          Learn more about what we do
        </a>
        <Tabs data={tabs} aria={`Discover Sigma X MTF`} readContent={true} />
      </div>

      <div className="book-block">
        <div
          className="tabs"
          role="tablist"
          aria-label="Price and Auction Book Information"
        >
          {book.map((book, b) => {
            return (
              <button
                className={`stripped-button tab${book.active ? ' active' : ''}`}
                key={`book-${b}`}
                role="tab"
                aria-describedby={book.active ? `book-content-${b}` : ''}
                aria-controls={`book-content-${b}`}
                aria-selected={book.active}
                aria-label={`View ${book.label}`}
                onClick={(e) => handleBookClick(e, b)}
              >
                {book.label}
              </button>
            );
          })}
        </div>
        <div className="tabs-body" tabIndex={0}>
          {book.map((book, b) => {
            return (
              <div
                className={`book-content${!book.active ? ' display-none' : ''}`}
                key={`book-content-${b}`}
                id={`book-content-${b}`}
                role="tabpanel"
                aria-live={book.active ? 'polite' : 'off'}
              >
                <span>{book.content}</span>
              </div>
            );
          })}

          <div className="learn-more-link">
            <a
              aria-label="Learn more by email"
              href="mailto:gssigmaxmtf@gs.com"
            >
              Learn more about our services
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
